import { render, staticRenderFns } from "./TraderRatioPositions.vue?vue&type=template&id=c29a69d6&scoped=true&"
import script from "./TraderRatioPositions.vue?vue&type=script&lang=js&"
export * from "./TraderRatioPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29a69d6",
  null
  
)

export default component.exports